<tdoe-layout [appName]="title" logo="/assets/TDOE-Color-Logo-300x119.png"
             [pageTitle]="title" [flyoutCommands]="[]">
  <router-outlet page></router-outlet>
  <ng-container footer>
    <!-- Anything to embed in footer -->
    </ng-container>
</tdoe-layout>